export const FORGOT_PASSWORD_FORM_EMAIL_PLACEHOLDER = 'forgot-password-form.email-placeholder';
export const FORGOT_PASSWORD_EMAIL_INVALID_ERROR_MESSAGE = 'forgot-password-form.email-invalid-error-message';
export const FORGOT_PASSWORD_FORM_SUBMIT_BUTTON_LABEL = 'forgot-password-form.submit-button-label';
